import 'reset-css';
import 'inpock-ui-react/dist/src/main.css';
import { BrowserRouter, Outlet, Route, Routes } from 'react-router-dom';
import { useState } from 'react';

import { AxiosError } from 'axios';

import { ErrorBoundary, ErrorPage } from './components/layouts';
import {
  AnonymousOrdersDetailPage,
  AnonymousPage,
  AnonymousCashReceiptPage,
  CheckoutPage,
  NotFound404,
  PayFailPage,
  PaySuccessPage,
  ProductPage,
  ProductV2Page,
  CustomerOrdersDetailPage,
  CustomerOrdersPage,
  CustomerCashReceiptPage,
  CustomerRedirectPage,
  ReviewModifyPage,
  ReviewRegisterPage,
  PayCallbackPage,
  MarketPage,
  MarketV2Page,
  DeprecatedReviewModifyPage,
  DeprecatedReviewRegisterPage,
  CartPage,
} from './pages';
import { ScrollToTop } from './utils';
import { ProtectedRoute } from './components/common/ProtectedRoute';
import { OrderLineProvider } from './components/orders/OrderLineContext';
import { SectionRefsProvider } from './components/checkout/SectionContext';

export function App() {
  const [error, setError] = useState<Error | AxiosError | null>(null);

  return (
    <ErrorBoundary FallbackComponent={ErrorPage} setError={setError}>
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/:username" element={<MarketPage />} />
          <Route path="/v2/:username" element={<MarketV2Page />} />

          {/* deprecated */}
          <Route path="/orders/review/:id/modify" element={<DeprecatedReviewModifyPage />} />
          <Route path="/orders/review/:id/register" element={<DeprecatedReviewRegisterPage />} />

          {/* 상품 */}
          <Route path="/products/:id">
            <Route index element={<ProductPage />} />
          </Route>

          {/* 상품 v2 */}
          <Route path="/v2/products/:id">
            <Route index element={<ProductV2Page />} />
          </Route>

          {/* 장바구니 */}
          <Route path="/cart" element={<CartPage />} />

          {/* 결제 */}
          <Route
            path="/checkout"
            element={
              <SectionRefsProvider>
                <CheckoutPage />
              </SectionRefsProvider>
            }
          />
          {/* 회원 */}
          <Route
            path="/customer/orders"
            element={
              <ProtectedRoute needAuth>
                <Outlet />
              </ProtectedRoute>
            }
          >
            <Route index element={<CustomerOrdersPage />} />
            <Route
              path=":id"
              element={
                <OrderLineProvider>
                  <CustomerOrdersDetailPage />
                </OrderLineProvider>
              }
            />
            <Route path="review/:id/modify" element={<ReviewModifyPage />} />
            <Route path="review/:id/register" element={<ReviewRegisterPage />} />
            <Route path=":id/cash-receipt" element={<CustomerCashReceiptPage />} />
          </Route>
          {/* 알림톡 customre 오타 대응 */}
          <Route path="/customre/orders/:id" element={<CustomerRedirectPage />} />

          {/* 비회원 */}
          <Route path="/anonymous" element={<AnonymousPage />} />
          <Route
            path="/anonymous/orders/:id"
            element={
              <ProtectedRoute needNonMemberAuth>
                <OrderLineProvider>
                  <AnonymousOrdersDetailPage />
                </OrderLineProvider>
              </ProtectedRoute>
            }
          />
          <Route
            path="/anonymous/orders/:id/cash-receipt"
            element={
              <ProtectedRoute needNonMemberAuth>
                <AnonymousCashReceiptPage />
              </ProtectedRoute>
            }
          />

          {/* 결제 성공 여부 */}
          <Route path="/pay/callback" element={<PayCallbackPage />} />
          <Route path="/pay/callback/fail" element={<PayFailPage />} />
          <Route path="/pay/callback/success" element={<PaySuccessPage />} />

          {/* Not Found */}
          <Route path="*" element={<NotFound404 />} />
        </Routes>
      </BrowserRouter>
    </ErrorBoundary>
  );
}
